<template>
  <el-dialog :visible.sync="visible"
             :title="$t('activiti.batchApproval')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="80%">
    <el-form>
      <div class="location-layout">
        <el-button style="width: 50px; margin-top: 10px"
                   class="M-search"
                   @click="approved(1)"
                   type="primary">{{ $t('activiti.agree') }}
        </el-button>
        <el-button :disabled='isDisable'
                   style="width: 50px; margin-top: 10px"
                   class="disagree M-search"
                   @click="approved(0)">{{ $t('activiti.disagree') }}
        </el-button>
        <el-input style="width: 100%; margin-top: 20px; position: relative;"
                  type="textarea"
                  :rows="4"
                  :placeholder="$t('activiti.pleaseEnterApprovalOpinion')"
                  maxlength="1000"
                  show-word-limit
                  v-model="textarea">
        </el-input>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data() {
    return {
      visible: false,
      isDisable: true,
      textarea: '',
      userId: '',
      userIds: '', // 更新用户id的字符串用逗号分隔
      taskIds: [], // 审批Id的list
      dataForm: [] // 传递过来的审批列表
    }
  },
  watch: {
    textarea(val) {
      if (val.trim() === '' || val === undefined || val === null) {
        this.isDisable = true
      } else {
        this.isDisable = false
      }
    }
  },
  methods: {
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.textarea = ''
        this.$request.get('/sys/commuser/userInfo').then((res) => {
          this.userId = res.user.userId
        }).catch((err) => {
          console.log(err)
        })
        let userList = []
        this.taskIds = []
        for (let i = 0; i < this.dataForm.length; i++) {
          this.taskIds.push(this.dataForm[i].taskId)
          let id = ''
          if (this.dataForm[i].businessKey !== '' && this.dataForm[i].businessKey) {
            let list = this.dataForm[i].businessKey.split('-')
            // businessType = list[0]
            id = list[1]
          }
          userList.push(id)
        }
        this.userIds = userList.join(',')
      })
    },
    // 批量审批
    approved: debounce(function (type) {
      // 批量更新用户表 type 1-50 0-40 userId逗号分隔字符串
      let comment = ''
      let registrationApprovaStatus = ''
      if (type === 1) {
        registrationApprovaStatus = 50
        comment = this.$t('activiti.agree') + '-' + this.textarea
      } else if (type === 0) {
        registrationApprovaStatus = 40
        comment = this.$t('activiti.disagree') + '-' + this.textarea
      }
      // 批量审批工作流同时更新用户和工作流
      this.$request.post('/sys/commuser/batchApproval',
        {
          userIds: this.userIds,
          registrationApprovaStatus: registrationApprovaStatus,
          batchAuditMap: {
            variables: { auditStatus: type },
            userId: this.userId,
            taskIds: this.taskIds,
            comment: comment,
            optUserId: this.userIds
          }
        }
      ).then((res, total, code, data) => {
        this.$message({
          message: this.$t('activiti.registrationComplete'),
          type: 'success',
          showClose: true,
          duration: 2000,
          onClose: () => {
            this.visible = false
            this.$emit('refreshDataList')
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }, 2000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss" scope>
.el-dialog__body {
  padding: 10px 20px 64px 20px !important;
  color: #606266;
  font-size: 14px;
}
.disagree:hover {
  color: #606266;
  background-color: #fff !important;
  border-color: #dcdfe6;
}
.disagree.el-button.is-disabled:hover {
  color: #c0c4cc;
  background-color: #fff !important;
  border-color: #dcdfe6;
}
</style>
